var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('div', {
    staticClass: "row page-title-header"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "page-header"
  }, [_c('b-breadcrumb', {
    staticClass: "m-0"
  }, [_c('b-breadcrumb-item', {
    attrs: {
      "to": {
        name: 'DashboardHome'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-home"
  })]), _c('b-breadcrumb-item', {
    attrs: {
      "active": ""
    }
  }, [_vm._v("LINE 應用中心")]), _c('b-breadcrumb-item', {
    attrs: {
      "active": ""
    }
  }, [_vm._v("LINE 聊天")])], 1)], 1)])]), _c('b-modal', {
    attrs: {
      "id": "modal-name",
      "title": "變更顯示名稱",
      "ok-title": "儲存",
      "cancel-title": "取消",
      "centered": ""
    }
  }, [_c('b-input', {
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "maxlength": "20",
      "placeholder": "變更顯示名稱"
    }
  })], 1), _c('b-modal', {
    attrs: {
      "id": "modal-tags",
      "title": "編輯標籤",
      "ok-title": "儲存",
      "cancel-title": "取消",
      "centered": ""
    }
  }, [_c('div', {
    staticClass: "border rounded p-1"
  }, [_vm._l(_vm.tags, function (i) {
    return _c('b-badge', {
      key: i,
      staticClass: "m-1",
      attrs: {
        "variant": "dark"
      }
    }, [_vm._v(" " + _vm._s(i) + " "), _c('button', {
      staticClass: "btn btn-xs p-0"
    }, [_c('i', {
      staticClass: "fa fa-remove text-white"
    })])]);
  }), _c('b-input', {
    staticClass: "border-0",
    attrs: {
      "type": "text",
      "maxlength": "40",
      "placeholder": "輸入標籤"
    }
  })], 2), _c('div', {
    staticClass: "h6 mt-3"
  }, [_vm._v("現有標籤")]), _vm._l(_vm.tags, function (i) {
    return _c('b-button', {
      key: i,
      staticClass: "m-1 text-dark",
      attrs: {
        "variant": "secondary",
        "size": "xs"
      }
    }, [_vm._v(" " + _vm._s(i) + " ")]);
  })], 2), _c('b-modal', {
    attrs: {
      "id": "modal-note",
      "title": "新增記事本",
      "ok-title": "儲存",
      "cancel-title": "取消",
      "centered": ""
    }
  }, [_c('b-textarea', {
    staticClass: "form-control",
    attrs: {
      "maxlength": "300",
      "placeholder": "你可於此新增用戶的相關資訊，且記事本中的資訊不會向對方公開",
      "rows": "10"
    }
  })], 1), _c('b-nav', {
    staticClass: "border-bottom-0",
    attrs: {
      "tabs": ""
    }
  }, [_c('b-nav-item', {
    attrs: {
      "active": ""
    }
  }, [_vm._v("OA 訊息")]), _c('b-nav-item', [_vm._v("聊天室")])], 1), _c('b-card', {
    staticClass: "chatroom d-flex flex-row",
    attrs: {
      "no-body": ""
    }
  }, [_c('div', {
    ref: "chatlist",
    staticClass: "chat-list position-relative d-flex flex-column border-right"
  }, [_c('div', {
    staticClass: "header px-3 pt-3 pb-2 border-bottom"
  }, [_c('div', {
    staticClass: "search mb-2"
  }, [_c('i', {
    staticClass: "fa fa-search",
    attrs: {
      "aria-hidden": "true"
    }
  }), _c('b-form-input', {
    attrs: {
      "type": "search",
      "placeholder": "姓名搜尋"
    },
    model: {
      value: _vm.keyword,
      callback: function callback($$v) {
        _vm.keyword = typeof $$v === 'string' ? $$v.trim() : $$v;
      },
      expression: "keyword"
    }
  })], 1), _c('div', {
    staticClass: "row"
  }, [_c('b-dropdown', {
    ref: "roomTypeFilter",
    staticClass: "filter col-6",
    attrs: {
      "variant": !_vm.currentRoomType ? 'light' : _vm.currentRoomType.variant
    },
    scopedSlots: _vm._u([{
      key: "button-content",
      fn: function fn() {
        return [_c('div', {
          staticClass: "flex-fill"
        }, [_vm._v(" " + _vm._s(!_vm.currentRoomType ? "對話類型" : _vm.currentRoomType.text) + " ")])];
      },
      proxy: true
    }])
  }, _vm._l(_vm.roomTypeFilters, function (i) {
    return _c('div', {
      key: i.value,
      staticClass: "item py-1 px-3",
      on: {
        "click": function click($event) {
          return _vm.singleFilterSelect(i);
        }
      }
    }, [_c('span', {
      staticClass: "d-flex justify-content-between align-items-center"
    }, [_c('i', {
      class: "fa fa-check ".concat(_vm.currentRoomType != i && 'text-white', " mr-3"),
      attrs: {
        "aria-hidden": "true"
      }
    }), _c('span', {
      class: "mb-0 px-3 py-2 badge badge-".concat(i.variant, " flex-fill")
    }, [_vm._v(_vm._s(i.text))])])]);
  }), 0), _c('b-dropdown', {
    ref: "roomStatusFilter",
    staticClass: "filter col-6",
    scopedSlots: _vm._u([{
      key: "button-content",
      fn: function fn() {
        return [_c('div', {
          staticClass: "flex-fill"
        }, [_vm._v("處理狀態")])];
      },
      proxy: true
    }])
  }, [_c('div', {
    staticClass: "search mb-2 px-2"
  }, [_c('i', {
    staticClass: "fa fa-search",
    attrs: {
      "aria-hidden": "true"
    }
  }), _c('b-form-input', {
    attrs: {
      "type": "search",
      "placeholder": "搜尋"
    },
    model: {
      value: _vm.roomStatusKeyword,
      callback: function callback($$v) {
        _vm.roomStatusKeyword = typeof $$v === 'string' ? $$v.trim() : $$v;
      },
      expression: "roomStatusKeyword"
    }
  })], 1), _vm._l(_vm.roomStatusFilters.filter(function (x) {
    return _vm.roomStatusKeyword == null || _vm.roomStatusKeyword == '' ? true : x.text.indexOf(_vm.roomStatusKeyword) >= 0;
  }), function (i) {
    return _c('div', {
      key: i.value,
      staticClass: "item py-1 px-3",
      on: {
        "click": function click($event) {
          return _vm.multiFilterSelect(i);
        }
      }
    }, [_c('span', {
      staticClass: "d-flex justify-content-between align-items-center"
    }, [_c('i', {
      class: "fa ".concat(_vm.currentRoomStatus.includes(i) ? 'fa-check-square-o' : 'fa-square-o', " mr-3"),
      attrs: {
        "aria-hidden": "true"
      }
    }), _c('span', {
      class: "mb-0 px-3 py-2 badge badge-".concat(i.variant, " flex-fill")
    }, [_vm._v(_vm._s(i.text))])])]);
  })], 2)], 1)]), _c('b-list-group', {
    staticClass: "list list-group-flush"
  }, [_vm.customers.length > 0 ? _vm._l(_vm.customers, function (i) {
    return _c('b-list-group-item', {
      key: i.id,
      staticClass: "d-flex align-items-center border-0",
      attrs: {
        "role": "button",
        "variant": _vm.chatroomId == i.id ? 'secondary' : 'default'
      },
      on: {
        "click": function click() {
          _vm.chatroomId = i.id;
        }
      }
    }, [_c('b-avatar', {
      staticClass: "mr-3",
      attrs: {
        "src": i.avatar_url
      }
    }), _c('div', {
      staticClass: "mr-auto font-weight-bold text-nowrap"
    }, [_vm._v(" " + _vm._s(i.name) + " "), _c('div', {
      staticClass: "text-muted small"
    }, [_vm._v(" " + _vm._s(i.message) + " ")]), i.status ? _c('b-badge', {
      attrs: {
        "pill": "",
        "variant": i.status.variant
      }
    }, [_vm._v(" " + _vm._s(i.status.text))]) : _vm._e()], 1), _c('div', {
      staticClass: "text-muted small text-center align-self-start"
    }, [_c('div', {
      staticClass: "mb-1"
    }, [_vm._v(_vm._s(_vm.formatDate(i.updated_at)))]), i.unread > 0 ? _c('b-badge', {
      attrs: {
        "pill": "",
        "variant": "primary"
      }
    }, [_vm._v(_vm._s(i.unread))]) : _vm._e()], 1)], 1);
  }) : _c('b-list-group-item', {
    staticClass: "empty"
  }, [_c('div', {
    staticClass: "mt-3 text-dark small"
  }, [_vm._v("目前沒有名單")])])], 2)], 1), _c('div', {
    staticClass: "resizer",
    on: {
      "mousedown": _vm.resizeStart,
      "mouseup": _vm.resizeEnd
    }
  }, [_c('i', {
    staticClass: "fa fa-ellipsis-v",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _c('div', {
    staticClass: "chatbox flex-fill d-flex flex-column border-right"
  }, [_c('div', {
    staticClass: "header"
  }, [_c('div', {
    staticClass: "\n            d-flex\n            justify-content-between\n            px-3\n            py-2\n            border-bottom\n            flex-wrap\n          "
  }, [_c('div', {
    staticClass: "font-weight-bold"
  }, [_c('b-avatar', {
    staticClass: "mr-3"
  }, [_c('img', {
    staticClass: "img-fluid",
    attrs: {
      "src": _vm.customers[0].avatar_url
    }
  })]), _vm._v(" " + _vm._s(_vm.customers[0].name) + " ")], 1), _c('div', {
    staticClass: "d-flex"
  }, [_c('b-button', {
    staticClass: "m-1",
    on: {
      "click": function click() {
        var msg = Object.assign(_vm.messages[1]);
        _vm.messages = [msg].concat(_vm.messages);
        _vm.unread = true;
      }
    }
  }, [_vm._v(" Test Message")]), _c('b-button', {
    staticClass: "m-1",
    attrs: {
      "variant": "outline-success"
    }
  }, [_c('i', {
    staticClass: "fa fa-comments-o",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" 待處理")]), _c('b-button', {
    staticClass: "m-1",
    attrs: {
      "variant": "outline-dark"
    }
  }, [_c('i', {
    staticClass: "fa fa-check-circle-o",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" 處理完畢")]), _c('b-button', {
    staticClass: "m-1",
    attrs: {
      "variant": "outline-dark"
    },
    on: {
      "click": function click() {
        _vm.isMessageSearching = !_vm.isMessageSearching;
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-search",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" 搜尋")]), _c('b-dropdown', {
    staticClass: "m-1",
    attrs: {
      "variant": "outline-dark"
    },
    scopedSlots: _vm._u([{
      key: "button-content",
      fn: function fn() {
        return [_c('i', {
          staticClass: "fa fa-sign-in m-0 mr-1",
          attrs: {
            "aria-hidden": "true"
          }
        }), _vm._v(" 指派他人 ")];
      },
      proxy: true
    }])
  }, [_c('b-dropdown-item', {
    attrs: {
      "href": "#"
    }
  }, [_c('b-avatar', {
    attrs: {
      "size": "2rem"
    }
  }), _vm._v(" 黃智彬 ")], 1), _c('b-dropdown-item', {
    attrs: {
      "href": "#"
    }
  }, [_c('b-avatar', {
    attrs: {
      "size": "2rem"
    }
  }), _vm._v(" 黃智彬 ")], 1), _c('b-dropdown-item', {
    attrs: {
      "href": "#"
    }
  }, [_c('b-avatar', {
    attrs: {
      "size": "2rem"
    }
  }), _vm._v(" 黃智彬 ")], 1)], 1), _c('b-button', {
    staticClass: "m-1",
    attrs: {
      "variant": "outline-dark"
    }
  }, [_c('i', {
    staticClass: "fa fa-check m-0 text-success",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" 完成對話 ")])], 1)]), _vm.isMessageSearching ? _c('div', {
    staticClass: "search-message p-2 border-bottom d-flex"
  }, [_c('b-form-input', {
    staticClass: "flex-fill",
    attrs: {
      "size": "sm",
      "type": "search",
      "placeholder": "輸入搜尋內容"
    }
  }), _c('b-button', {
    staticClass: "btn btn-light ml-2",
    on: {
      "click": function click() {
        _vm.isMessageSearching = !_vm.isMessageSearching;
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-remove"
  })])], 1) : _vm._e()]), _c('div', {
    ref: "messages",
    staticClass: "message-container d-flex flex-column-reverse flex-fill px-3"
  }, [_vm._l(_vm.messages, function (message, idx) {
    return _c('div', {
      key: idx,
      class: ['message-box', 'my-2', message.customer_id == 29 && 'owner']
    }, [_vm.checkStrike(_vm.messages, idx) ? _c('div', {
      staticClass: "strike small text-muted pb-2"
    }, [_vm._v(" " + _vm._s(_vm.formatDate(_vm.messages[idx].created_at)) + " ")]) : _vm._e(), _c('div', {
      staticClass: "message-wrapper"
    }, [_c('div', {
      staticClass: "d-flex align-items-start"
    }, [message.customer_id != 29 ? _c('b-avatar', {
      staticClass: "mr-2",
      attrs: {
        "src": message.customer.data ? message.customer.data.pictureUrl || message.customer.avatar_url : message.customer.avatar_url
      }
    }) : _vm._e(), _c('div', [message.customer_id != 29 ? _c('small', [_vm._v(_vm._s(message.customer.name))]) : _vm._e(), _c('div', {
      staticClass: "message py-2 px-3 mt-1"
    }, [_vm._v(" " + _vm._s(message.content) + " ")])])], 1), _c('div', {
      staticClass: "small text-muted text-right mt-1"
    }, [message.customer_id == 29 ? _c('svg', {
      attrs: {
        "xmlns": "http://www.w3.org/2000/svg",
        "viewBox": "0 0 448 512",
        "height": "12",
        "fill": "#1e88e5"
      }
    }, [_c('path', {
      attrs: {
        "d": "M438.6 105.4C451.1 117.9 451.1 138.1 438.6 150.6L182.6 406.6C170.1 419.1 149.9 419.1 137.4 406.6L9.372 278.6C-3.124 266.1-3.124 245.9 9.372 233.4C21.87 220.9 42.13 220.9 54.63 233.4L159.1 338.7L393.4 105.4C405.9 92.88 426.1 92.88 438.6 105.4H438.6z"
      }
    })]) : _vm._e(), _vm._v(" " + _vm._s(_vm.format(new Date(message.created_at), "HH:mm")) + " ")])])]);
  }), _c('div', {
    staticClass: "text-center"
  }, [_vm.loading ? _c('b-spinner', {
    staticClass: "position-absolute",
    attrs: {
      "variant": "secondary",
      "small": ""
    }
  }) : _vm._e()], 1)], 2), _c('div', {
    staticClass: "border-top position-relative"
  }, [_c('div', {
    staticClass: "position-absolute unread d-flex justify-content-between px-3"
  }, [_c('span'), _vm.unread ? _c('b-button', {
    attrs: {
      "variant": "dark",
      "size": "sm",
      "pill": ""
    },
    on: {
      "click": _vm.scrollToBottom
    }
  }, [_vm._v(" 新訊息 ")]) : _vm._e(), !_vm.bottom ? _c('b-button', {
    staticClass: "px-2",
    attrs: {
      "variant": "dark",
      "size": "sm",
      "pill": ""
    },
    on: {
      "click": _vm.scrollToBottom
    }
  }, [_c('svg', {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 448 512",
      "height": "16",
      "fill": "white"
    }
  }, [_c('path', {
    attrs: {
      "d": "M224 416c-8.188 0-16.38-3.125-22.62-9.375l-192-192c-12.5-12.5-12.5-32.75 0-45.25s32.75-12.5 45.25 0L224 338.8l169.4-169.4c12.5-12.5 32.75-12.5 45.25 0s12.5 32.75 0 45.25l-192 192C240.4 412.9 232.2 416 224 416z"
    }
  })])]) : _vm._e()], 1), _c('ChatBox', {
    attrs: {
      "canAttach": "",
      "canSticker": "",
      "canImage": ""
    },
    on: {
      "insertSticker": _vm.insertSticker,
      "insertImage": _vm.insertImage,
      "insertFile": _vm.insertFile
    },
    model: {
      value: _vm.message,
      callback: function callback($$v) {
        _vm.message = $$v;
      },
      expression: "message"
    }
  })], 1)]), _c('div', {
    staticClass: "profile"
  }, [_c('div', {
    staticClass: "text-center p-3"
  }, [_c('b-avatar', {
    staticClass: "my-4",
    attrs: {
      "size": "13rem",
      "src": _vm.customers[0].avatar_url
    }
  }), _c('div', {
    staticClass: "h4 p-2"
  }, [_vm._v(" " + _vm._s(_vm.customers[0].name) + " "), _c('button', {
    directives: [{
      name: "b-modal",
      rawName: "v-b-modal.modal-name",
      modifiers: {
        "modal-name": true
      }
    }],
    staticClass: "btn h4"
  }, [_c('i', {
    staticClass: "fa fa-pencil",
    attrs: {
      "aria-hidden": "true"
    }
  })])]), _c('div', {
    staticClass: "tags"
  }, [_vm._l(_vm.tags, function (i) {
    return _c('b-badge', {
      key: i,
      staticClass: "m-1",
      attrs: {
        "variant": "dark"
      }
    }, [_vm._v(_vm._s(i))]);
  }), _c('button', {
    directives: [{
      name: "b-modal",
      rawName: "v-b-modal.modal-tags",
      modifiers: {
        "modal-tags": true
      }
    }],
    staticClass: "btn"
  }, [_c('i', {
    staticClass: "fa fa-pencil",
    attrs: {
      "aria-hidden": "true"
    }
  })])], 2)], 1), _c('b-list-group', {
    staticClass: "border-top border-bottom accordion",
    attrs: {
      "id": "accordionExample",
      "flush": ""
    }
  }, [_c('b-list-group-item', {
    directives: [{
      name: "b-modal",
      rawName: "v-b-modal.modal-note",
      modifiers: {
        "modal-note": true
      }
    }],
    staticClass: "d-flex justify-content-between align-items-center",
    attrs: {
      "role": "button"
    }
  }, [_vm._v(" 記事本 "), _c('i', {
    staticClass: "fa fa-plus"
  })]), _c('b-list-group-item', {
    attrs: {
      "role": "button"
    }
  }, [_c('div', {
    directives: [{
      name: "b-toggle",
      rawName: "v-b-toggle.collapse-profile",
      modifiers: {
        "collapse-profile": true
      }
    }],
    staticClass: "d-flex justify-content-between align-items-center"
  }, [_vm._v(" 基本資料 "), _c('i', {
    staticClass: "fa fa-chevron-down",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _c('b-collapse', {
    staticClass: "py-3",
    attrs: {
      "id": "collapse-profile"
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "InputPhone"
    }
  }, [_vm._v("行動電話")]), _c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "tel",
      "id": "InputPhone",
      "placeholder": "請使用 0-9,+,-組合的電話號碼格式"
    }
  })]), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "InputEmail"
    }
  }, [_vm._v("電子信箱")]), _c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "email",
      "id": "InputEmail",
      "placeholder": "請輸入電子信箱"
    }
  })]), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "InputBirthday"
    }
  }, [_vm._v("生日")]), _c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "date",
      "id": "InputBirthday",
      "placeholder": "日期格式為西元年月日，如 1990-01-01"
    }
  })]), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "InputGender"
    }
  }, [_vm._v("性別")]), _c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "InputGender",
      "placeholder": "性別"
    }
  })]), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "InputLanguage"
    }
  }, [_vm._v("語言")]), _c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "InputLanguage",
      "placeholder": "語言"
    }
  })]), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "InputCountry"
    }
  }, [_vm._v("國家")]), _c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "InputCountry",
      "placeholder": "國家"
    }
  })]), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "InputCity"
    }
  }, [_vm._v("現居城市")]), _c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "InputCity",
      "placeholder": "現居城市"
    }
  })])])], 1)], 1)], 1)])], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }